import { GetAppSettings } from '../AppSettings';

export const getCurrentPosition = async (options) => {
  return new Promise<GeolocationPosition | null>((resolve) => {
    const location = window.navigator && window.navigator.geolocation;
    if (!location) {
      // reject(new Error('Failed getting location'));
      console.warn('Failed getting location');
      resolve(null);
      return;
    }
    location.getCurrentPosition(
      (position) => {
        resolve(position);
      },
      (error) => {
        //reject(new Error(error.message));
        console.warn(error.message);
        resolve(null);
      },
      options
    );
  });
};

export const getMapImageUrl = (coords, dimensions, maptype = 'roadmap') => {
  const appSettings = GetAppSettings();
  const apiKey = appSettings.GoogleMapsApiKey;

  let { scale, zoom = 16, w, h } = dimensions;
  const { longitude, latitude, accuracy } = coords;
  const origW = w;
  const origH = h;

  if (!longitude || !latitude) {
    return null;
  }

  if (w > 640 || h > 640) {
    scale = 2;
    w /= 2;
    h /= 2;
    if (w > 640) {
      w = 640;
    }
    if (h > 640) {
      h = 640;
    }
  }

  if (w === 640 && h < 640) {
    h = origH * (w / origW);
  } else if (h === 640 && w < 640) {
    w = origW * (h / origH);
  }

  if (!zoom) {
    if (accuracy <= 500) {
      zoom = 16;
    } else if (accuracy <= 1200) {
      zoom = 15;
    } else if (accuracy <= 2500) {
      zoom = 14;
    } else if (accuracy <= 6000) {
      zoom = 13;
    } else if (accuracy <= 16000) {
      zoom = 12;
    } else if (accuracy <= 30000) {
      zoom = 11;
    } else if (accuracy <= 45000) {
      zoom = 10;
    }
  }

  return `https://maps.googleapis.com/maps/api/staticmap?zoom=${zoom}&scale=${scale}&size=${Math.floor(w)}x${Math.floor(
    h
  )}&maptype=${maptype}&sensor=true&key=${apiKey}&markers=color:blue%7C${latitude},${longitude}`;
};
